import { createStore } from 'vuex'

export default createStore({
  state: {
    isLogin: false,
    username: ''
  },
  getters: {
    isLogin: function (state) {
      return state.isLogin
    },
    getUserName: function (state) {
      return state.username
    },
  },
  mutations: {
    changeLoginStat (state, value) {
      state.isLogin = value
    },
    changeUser (state, value) {
      state.username = value
    },
  },
  actions: {
  },
  modules: {
  }
})
